import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css.css';
import ElementUI from 'element-ui';
import VueAxios from 'vue-axios';
import http from '@/utils/index';
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/store/index';

Vue.use(ElementUI, VueAxios);
Vue.config.productionTip = false;
Vue.prototype.$http = http.service;
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0;
    // 拦截所有的路由跳转：手动把滚动条的位置设置到顶部
    document.documentElement.scrollTop = 0;
    next();
});
//配置安全密钥
window._AMapSecurityConfig = {
    securityJsCode: '98f2b392d5bd89d39b361f3267c5349c', //*  安全密钥
};
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
